export default __webpack_public_path__ + "static/media/pencil.c4c563e7.svg";